---
layout: blog
title: "Upcoming Features Preview: What We Are Building"
date: "2025-01-15"
author: "Product Team"
description: "A sneak peek at the features coming to Corral in Q1 2025. This is a draft post visible only in development environments."
tags:
  - Roadmap
  - Preview
---

> **Note:** This is a draft post. It's visible in development but won't appear in production builds.

We're excited to share a preview of what's coming to Corral in early 2025. Our roadmap is shaped by feedback from our Design Partners and the challenges we see enterprises facing as they adopt AI.

## Multi-Model Support

Right now, Corral works with Azure OpenAI. In Q1, we're expanding to support:

- **Anthropic Claude** — Deploy Claude models within your Azure tenant
- **Open-source models** — Run Llama, Mistral, and others on your infrastructure
- **Model routing** — Automatically select the best model for each task

This gives you flexibility without sacrificing our zero-trust architecture.

## Workflow Automation

Beyond chat interfaces, we're building:

- **Scheduled tasks** — Run AI operations on a schedule
- **Event triggers** — Respond to changes in your systems
- **Multi-step workflows** — Chain operations together

Think of it as "AI-powered automation that never sees your data."

## Enhanced Analytics

Understanding how AI is being used (without compromising privacy):

- **Usage patterns** — Aggregated metrics, no content logging
- **Cost attribution** — Track spending by team or project
- **Performance insights** — Latency, throughput, error rates

## API for Custom Integrations

For teams building custom applications:

```typescript
import { Corral } from '@corral/sdk';

const corral = new Corral({
  endpoint: 'https://your-tenant.corral.ai',
  // Authentication via your Azure AD
});

const response = await corral.chat({
  messages: [{ role: 'user', content: 'Summarize this document...' }],
  documents: ['sharepoint://path/to/doc.pdf']
});
```

## Timeline

- **January 2025** — Multi-model support (beta)
- **February 2025** — Workflow automation (beta)
- **March 2025** — Analytics dashboard, public API

---

*Want early access? [Join our Design Partner Program](/partners) to get these features before general availability.*
